module.exports = __webpack_public_path__ + "static/media/SVN-Futura-Regular.df50b464.otf";